import { observer } from "mobx-react";
import { SharepointDestinationModel } from "@/common/commonForms";
import { useTranslation } from "@/stores/RootStoreContext";
import { DataTable, TableColumn } from "@/components-v2/DataTable";
import { Box, VBox } from "@/components-v2/Box";
import { Icon } from "@/components-v2/Icon";
import { Dialog } from "@/components-v2/Dialog";
import { Alert } from "@/components-v2/Alert";
import { MSelect } from "@/components-v2/Select";
import { LoadingIndicator } from "@/components-v2/LoadingIndicator";
import { LinkButton } from "@/components-v2/Button";
import { SharepointContentInDrive } from "./sharepointDomain";

export const ConfigureSharepointDestination = observer(
  ({ model }: { model: SharepointDestinationModel }) => {
    const { t } = useTranslation();
    const renderLink = (label: string) => (
      <LinkButton
        label={label}
        icon={"folder-open"}
        onClick={model.toggleSelectSharepointDestinationDialog}
        weight={"normal"}
      />
    );
    return (
      <Box alignItems={"center"}>
        {model.selectSharepointDestinationDialog && <SelectSharepointDestination model={model} />}
        <Box gap={"md"} alignItems={"center"}>
          {model.selectedSharepointDestination ? (
            <>
              <Icon name={"folder"} /> {model.selectedSharepointDestination.destinationFolderName}
              {renderLink(t("edit"))}
              <LinkButton
                weight={"normal"}
                label={t("reset")}
                icon={"arrow-counter-clockwise"}
                onClick={model.resetSharepointDestination}
              />
            </>
          ) : (
            renderLink(t("dbot.select-sharepoint-destination"))
          )}
        </Box>
      </Box>
    );
  },
);

const SelectSharepointDestination = observer(({ model }: { model: SharepointDestinationModel }) => {
  const { t } = useTranslation();
  const columns: TableColumn<SharepointContentInDrive>[] = [
    {
      align: "left",
      name: "name",
      label: "",
      getValue: (d) => (
        <Box>
          <Icon name={"folder"} /> {d.name}
        </Box>
      ),
    },
  ];

  return (
    <Dialog
      title={t("dbot.select-sharepoint-destination")}
      maxWidth={"sm"}
      onCancel={model.toggleSelectSharepointDestinationDialog}
      onSubmit={model.onSelectSharepointDestination}
      submitLabel={model.selectSharepointLabel}
    >
      <VBox gap={"md"}>
        {model.error && <Alert message={model.error} type={"error"} />}
        <MSelect model={model.sharepointDrive} />
        {model.sharepointParent && (
          <div>
            <LinkButton
              arrow={"left"}
              label={model.sharepointParent.name}
              onClick={model.navigateToParent}
            />
          </div>
        )}
        {model.isLoading && <LoadingIndicator />}
        {model.contentInSharepointDrive &&
          (model.contentInSharepointDrive.length > 0 ? (
            <DataTable
              tableColumns={columns}
              tableData={model.contentInSharepointDrive}
              getId={(p) => p.id}
              onRowClick={(p) => model.loadContentInSharepointDrive(model.sharepointDrive.value, p)}
            />
          ) : (
            <Alert type={"info"} message={t("sharepoint.no-content")} />
          ))}
      </VBox>
    </Dialog>
  );
});
